import mixpanel from 'mixpanel-browser';

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
  debug: process.env.NODE_ENV !== 'production',
  opt_out_tracking_by_default: process.env.NODE_ENV === 'testing'
});
